// Import all necessary Firebase services
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: 'AIzaSyCTKt5jTIz18LOWs3dfy-4BPJg73N208c0',
	authDomain: 'zippedriveralpha.firebaseapp.com',
	databaseURL: 'https://zippedriveralpha-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: 'zippedriveralpha',
	storageBucket: 'zippedriveralpha.firebasestorage.app',
	messagingSenderId: '839094425920',
	appId: '1:839094425920:web:7c2b9e251956eb74d702a5'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const rtdb = getDatabase(app);
const storage = getStorage(app);
const messaging = getMessaging(app);

// Enable logging in development
if (import.meta.env.DEV) {
	console.log('Firebase initialized with config:', firebaseConfig);
	console.log('Firebase app:', app);
	console.log('Auth service:', auth);
	console.log('Firestore service:', db);
	console.log('Realtime Database service:', rtdb);
	console.log('Storage service:', storage);
}

// Export initialized services and functions
export { app, auth, db, rtdb, storage, messaging };
